import React from 'react';

type GanttChartLoaderProps = {
  size?: 'sm' | 'md';
};

/** Mini schedule on one infinite CSS loop. A parent re-render does not restart it. */
function GanttChartLoaderBase({ size = 'md' }: GanttChartLoaderProps) {
  return (
    <div className={`gantt-chart-loader gantt-chart-loader--${size}`} aria-hidden>
      <span className="gantt-chart-loader__track gantt-chart-loader__track--1" />
      <span className="gantt-chart-loader__track gantt-chart-loader__track--2" />
      <span className="gantt-chart-loader__track gantt-chart-loader__track--3" />
      <span className="gantt-chart-loader__bar gantt-chart-loader__bar--1" />
      <span className="gantt-chart-loader__stem gantt-chart-loader__stem--1" />
      <span className="gantt-chart-loader__arm gantt-chart-loader__arm--1" />
      <span className="gantt-chart-loader__arrow gantt-chart-loader__arrow--1" />
      <span className="gantt-chart-loader__bar gantt-chart-loader__bar--2" />
      <span className="gantt-chart-loader__stem gantt-chart-loader__stem--2" />
      <span className="gantt-chart-loader__arm gantt-chart-loader__arm--2" />
      <span className="gantt-chart-loader__arrow gantt-chart-loader__arrow--2" />
      <span className="gantt-chart-loader__bar gantt-chart-loader__bar--3" />
    </div>
  );
}

export const GanttChartLoader = React.memo(GanttChartLoaderBase);
